<template>
  <div class="totals-sidebar bg-white d-flex flex-column justify-content-between">
    <div class="booking">
      <div class="d-flex justify-content-between">
        <p class="fs-14 color-grey-3 font-smoothing mb-0">Afrejsedato:</p>
        <p class="fs-14 mb-0">{{ bookingDate }}</p>
      </div>
      <div class="d-flex justify-content-between">
        <p class="fs-14 color-grey-3 font-smoothing mb-0">Afrejsetidspunkt:</p>
        <p class="fs-14 mb-0">{{ booking.time.HH }}:{{ booking.time.mm }}</p>
      </div>
      <div class="mt-4">
        <p class="fs-14 color-grey-3 font-smoothing mb-0">Destination:</p>
        <p class="fs-14 mb-0">{{ booking.destination }}</p>
        <p class="fs-14 mb-0">{{ booking.airport }}</p>
      </div>
      <div class="mt-4">
        <p class="fs-14 color-grey-3 font-smoothing mb-0">Booking:</p>
        <p class="fs-14 mb-0">{{ booking.number }}</p>
      </div>
    </div>
    <div>
      <div class="totals">
        <div class="d-flex justify-content-between">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Personer:</p>
          <p class="fs-14 mb-0">{{ cart.people.length }}</p>
        </div>
        <div class="d-flex justify-content-between">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Alm baggage:</p>
          <p class="fs-14 mb-0">{{ cart.luggageSmall.amount }}</p>
        </div>
        <div class="d-flex justify-content-between">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Stor bagage:</p>
          <p class="fs-14 mb-0">{{ cart.luggageLarge.amount }}</p>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Opsamlingspris:</p>
          <p class="fs-14 mb-0">{{ showOpsamlingspris ? prices.travel + ' kr.' : 'ikke valgt' }}</p>
        </div>
        
        <div class="d-flex justify-content-between mb-0">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Ekstra personer:</p>
          <p class="fs-14 mb-0">{{ prices.people }} kr.</p>
        </div>
        
        <div class="d-flex justify-content-between mb-0">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Ekstra bagage:</p>
          <p class="fs-14 mb-0">{{ prices.luggageSmall }} kr.</p>
        </div>
     
        <div class="d-flex justify-content-between mb-0">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Stor bagage:</p>
          <p class="fs-14 mb-0">{{ prices.luggageLarge }} kr.</p>
        </div>

        <div
          v-if="(Number(contact.address.zip) < puroadLevel.maxPostalNumber) && Boolean(puroadLevel.value)"
          class="d-flex justify-content-between mt-3 mb-3"
        >
          <p class="fs-14 color-grey-3 font-smoothing mb-0">
            {{ checkInText }}:
          </p>
          <p class="fs-14 fw-semibold mb-0">{{ checkInPrice }} kr.</p>
        </div>
        
        <div class="d-flex justify-content-between mt-3 mb-3">
          <p class="fs-14 color-grey-3 font-smoothing fw-semibold mb-0">Udrejse ialt:</p>
          <p class="fs-14 fw-semibold mb-0">{{ showUdrejseTotal ? prices.departtravel + ' kr.' : 'ikke valgt' }}</p>
        </div>

        <div class="d-flex justify-content-between mb-3" v-if="cart.serviceHjemrejse">
          <p class="fs-14 color-grey-3 font-smoothing fw-semibold mb-0" style="flex: 1; margin-right: 10px; word-wrap: break-word;">
            Hjemrejse{{ bookingHome.customsService ? ' (med toldservice)' : '' }}:
          </p>
          <p class="fs-14 fw-semibold mb-0" style="flex-shrink: 0;">{{ prices.totalHome }} kr.</p>
        </div>

        <div class="d-flex justify-content-between mt-3" v-if="prices.luggageAirshell > 0">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Airshell:</p>
          <p class="fs-14 mb-0">{{ prices.luggageAirshell }} kr.</p>
        </div>
        <div class="d-flex justify-content-between mb-3" v-if="prices.luggagePlasticBag > 0">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Kraftige poser:</p>
          <p class="fs-14 mb-0">{{ prices.luggagePlasticBag }} kr.</p>
        </div>

        <div class="d-flex justify-content-between mb-3" v-if="prices.priceAddition > 0">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Hastetillæg:</p>
          <p class="fs-14 mb-0">{{ prices.priceAddition }} kr.</p>
        </div>

        <div class="d-flex justify-content-between mb-3" v-if="(payment.couponValueCU > 0 || payment.couponError)">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Coupon:</p>
          <p class="fs-14 mb-0">{{ payment.couponValueCU }} kr. <!-- {{ payment.couponType === 'Value card' ? 'kr.' : couponExtension }} --></p>
        </div>

        <div class="d-flex justify-content-between mb-3">
          <p class="fs-14 color-grey-3 font-smoothing mb-0">Betalingsform:</p>
          <p class="fs-14 mb-0">{{ payment.type }}</p>
        </div>

        <div class="d-flex justify-content-between total-price">
          <h3 class="mb-0 total-price__label">Pris i alt</h3>
          <h3 class="mb-0 total-price__value fw-semibold">
            {{ prices.total.toFixed(2) }} kr.
            <span v-if="isPricingLoading" class="total-price__loading">opdaterer...</span>
          </h3>
        </div>
      </div>
      <button
        v-if="step !== 5"
        type="button"
        :class="'next-wrapper' + [' tag-mgr-clickable-step-'+this.step]"
        :disabled="nextDisabled"
        @click="handleClickNext"
      >
        <div class="next font-smoothing bg-blue d-flex align-items-center">
          <i class="icon-arrow-left color-white fs-20 text-center cursor-pointer" @click.stop="handleClickBack" />
          <p
            class="m-0 text-center color-white"
            :class="{'cursor-not-allowed opacity-50 ' : nextDisabled }"
            @click="errorDisplays()"
          >{{ buttonText }}</p>
          <i class="icon-arrow-right color-white fs-20 text-center" :class="{'cursor-not-allowed opacity-50 ' : nextDisabled }"></i>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TotalsSidebar',
  props: {
    step: { type: Number, required: true },
    disableNext: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isPricingLoading: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters([
      'cart',
      'prices',
      'booking',
      'bookingHome',
      'distributedLuggage',
      'payment',
      'contact',
      'puroadLevel'
    ]),
    nextDisabled() {
      const hasNoLuggage = this.cart.luggageSmall.amount === 0 && this.cart.luggageLarge.amount === 0;
      return this.disableNext || this.isLoading || (this.step === 2 && hasNoLuggage);
    },
    buttonText() {
      if (this.step < 4) return 'Næste';
      else if (this.step === 4) return 'Til Betaling';
      else return 'Afslut';
    },
    couponExtension() {
      if (this.payment.couponType === "" || typeof this.payment.couponType === 'undefined') {
        return null;
      }

      if(this.payment.couponType !== "Fast beløb") {
          return '%'
        } else {
          return 'kr.'
      }
    },
    bookingDate () {
      if (this.booking.date instanceof Date) {
        return ("0" + this.booking.date.getDate()).slice(-2) + "-" + ("0"+(this.booking.date.getMonth()+1)).slice(-2) + "-" + this.booking.date.getFullYear()
      }
      return this.booking.date
    },
    // Check if Udrejse service is selected
    showUdrejseTotal() {
      return this.cart.serviceUdrejse;
    },
    showOpsamlingspris() {
      // Opsamlingspris is only applicable if "udrejse" is chosen
      return this.cart.serviceUdrejse;
    },
    checkInText() {
      const { serviceUdrejse, serviceHjemrejse } = this.cart;
      
      if (!serviceUdrejse && serviceHjemrejse) {
        // Only Hjemrejse selected
        return this.puroadLevel.value === 'yes' ? 'bringe bagagen ved vejkant' : 'bringe bagagen til lejlighed';
      } else if (serviceUdrejse && serviceHjemrejse) {
        // Both services selected
        return this.puroadLevel.value === 'yes' ? 'modtage/bringe bagagen ved vejkant' : 'modtage/bringe bagagen til lejlighed';
      } else {
        // Only Udrejse or no services - keep original text
        return this.puroadLevel.value === 'yes' ? 'Check-in ved vejkant' : 'Check-in i lejlighed';
      }
    },
    checkInPrice() {
      const { serviceUdrejse, serviceHjemrejse } = this.cart;
      
      if (this.puroadLevel.value === 'yes') {
        return 0; // Free at roadside regardless of service type
      }
      
      if (serviceUdrejse && serviceHjemrejse) {
        // Both services selected - price is 300 DKK
        return 300;
      } else {
        // Only one service or no services - use normal fee
        return this.puroadLevel.fee;
      }
    }
  },
  methods: {
    ...mapMutations([
      'disableErrorDisplays',
      'enableErrorDisplays'
    ]),

    errorDisplays() {

      if (this.disableNext) {
        this.enableErrorDisplays();
      } else {
        this.disableErrorDisplays();
      }
    },
    handleClickNext () {
      if (this.nextDisabled) {
        return;
      }

      this.$emit('next');

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 250);
    },
    handleClickBack () {
      this.$emit('prev');

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 250);
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "../assets/scss/variables" as *;
  @use "../assets/scss/media-queries" as *;

  .totals-sidebar {
    width: 340px;
    padding: 60px 0 0;

    @include min-screen(992px) {
      position: sticky;
      top: 20px;
      height: fit-content;
      max-height: calc(100vh - 40px);
      overflow-y: auto;
      
      // Alternative approach for bottom sticking
      // Uncomment if you prefer bottom positioning
      // position: fixed;
      // bottom: 0;
      // right: 0;
      // top: auto;
      // max-height: 50vh;
    }

    @include max-screen(991px) {
      width: 100%;
    }

    .booking {
      padding: 0 60px;
    }

    .totals {
      padding: 60px 60px 40px;
      border-top: 1px solid $grey-1;
    }

    .total-price {
      &__label,
      &__value {
        font-size: 17px !important;
        line-height: 1.2 !important;
      }

      &__value {
        text-align: right;
      }

      &__loading {
        display: block;
        margin-top: 4px;
        font-size: 11px;
        font-weight: 400;
        color: $grey-3;
      }
    }

    .next-wrapper {
      display: block;
      border: none;
      outline: none;
      background: transparent;
      padding: 0;
      width: 100%;
      cursor: pointer;

      &:disabled {
        cursor: default;
      }
    }

    .next {
      p {
        width: calc(100% - 80px);
      }

      .icon-arrow-left {
        padding: 30px 0;
        width: 120px;
        background-color: $grey-3;
      }

      .icon-arrow-right {
        padding: 30px 20px 30px 0;
        margin-left: -50px;
        width: 80px;
      }
    }
  }
</style>
